// extracted by mini-css-extract-plugin
module.exports = {"text":"xmas-promo-banner_text__uCId9","link":"xmas-promo-banner_link__f9z0A","svg":"xmas-promo-banner_svg__91Gpe"};